// extracted by mini-css-extract-plugin
export default {"general":"Teasers_general--_LB","wrapper":"Teasers_wrapper--N1P","teaser":"Teasers_teaser--rI4","skeletWrapper":"Teasers_skeletWrapper--kH9"};